// src/components/layout/Footer.js

import React from 'react';

export const Footer = () => {
    return (
        <footer className="w-full text-center py-4 bg-gray-100 text-sm text-gray-600 border-t">
            © {new Date().getFullYear()} K3D Technology. Todos los derechos reservados.
        </footer>
    );
};